/* eslint react/no-danger: 0 */
import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, Alert } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PaymentFailed(props) {
  const {
    retryURL
  } = props;
  const {
    __
  } = useTranslator();
  const messages = [];
  messages.push( /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: __('#### Our online banking partner refused your payment.' + '\n' + 'We could not process your payment. We recommend that you:' + '\n' + '- Use another payment method if you think that your bank does not handle the "Verified by Visa protocol"' + '\n' + '- Try again if it might just be a temporary problem' + '\n' + '- Contact your bank to see why your payment was refused.', {
      withMarkdown: true
    })
  }, "message"));
  if (retryURL) {
    messages.push( /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: __('<p style="text-align: center; padding-top: 20px;">' + '<a href="%(retryURL)s" class="btn btn-color-main btn-outline">' + 'Use another payment method' + '</a>' + '</p>', {
        withHTML: true,
        retryURL
      })
    }, "additional"));
  }
  return /*#__PURE__*/_jsx(Base, {
    marginBottom: "base",
    children: /*#__PURE__*/_jsx(Alert, {
      message: messages,
      intent: "danger"
    })
  });
}